import { ProgressNoteData } from "@/modules/patients/detail/progress-note/types/progress-note-fragment-type"
import { chProgressNoteFragment$data } from "@/modules/patients/services/ch/__generated__/chProgressNoteFragment.graphql"
import { deProgressNoteFragment$data } from "@/modules/patients/services/de/__generated__/deProgressNoteFragment.graphql"
import { Country } from "@/types/__generated__/union-types"

const areAllDocumentsEmpty = (obj: ProgressNoteData, collections: string[]) =>
  collections.every((collectionName) => {
    const document = obj[collectionName as keyof typeof obj]
    return !document
  })

const areChDocumentsEmpty = (progressNote: ProgressNoteData) => {
  const collections: Array<keyof chProgressNoteFragment$data> = [
    "attestationGuardian",
    "ch_consultationReport",
    "ch_laboratoryPrescription",
    "ch_measRadiologyPrescription",
    "ch_neuropsychologicDiagnosticPrescription",
    "ch_nutritionalPrescription",
    "generalAttestation",
    "measLaboratoryPrescription",
    "physiotherapy",
    "prescription",
    "psychologicalPsychotherapy",
    "referralLetter",
    "sickLeave",
  ]

  return areAllDocumentsEmpty(progressNote, collections)
}

const areDeDocumentsEmpty = (progressNote: ProgressNoteData) => {
  const collections: Array<keyof deProgressNoteFragment$data> = [
    "attestationGuardian",
    "generalAttestation",
    "prescription",
    "referralLetter",
    "sickLeave",
    "therapyPrescription",
  ]

  return areAllDocumentsEmpty(progressNote, collections)
}

export const areDocumentsEmpty = (country: Country, progressNote: ProgressNoteData) => {
  switch (country) {
    case "CH":
      return areChDocumentsEmpty(progressNote)
    case "DE":
      return areDeDocumentsEmpty(progressNote)
  }
}
